import { type CandidateStatEntry } from "@crowdcoursing/api/openapi";

import { aggregateCandidateStatsByDate } from "./aggregateCandidateStatsByDate";

/** Latest total candidate count from candidacy stats (matches the Candidacy tab "Total Candidates" card). */
export const getTotalCandidateCountFromStats = (stats: CandidateStatEntry[] | null | undefined): number | null => {
  const aggregated = aggregateCandidateStatsByDate(stats);
  const mostRecent = aggregated[aggregated.length - 1];
  const totalStudents = mostRecent?.metrics?.totalStudents;

  if (!totalStudents || totalStudents <= 0) {
    return null;
  }

  return totalStudents;
};
